
/* eslint-disable arrow-body-style, max-len, comma-dangle */
import { find, uniqBy, flatten } from 'lodash';
import api from '@/services/api';
import { updateMarket, updateMarketContracts } from '@/utils/notifications';
import ls from '@/helpers/localStorage';

import { ORDERS, AVAILABLE_TIMESPANS, DEFAULT_TIMESPANS, ORDERS_WITH_TIMESPAN_FILTER, TIMESPANS } from './filters_consts';


const KEY_SHOULD_SHOW_TIMESPAN = 'watchlist-should-show-timespan';
const KEY_SELECTED_ORDER = 'watchlist-selected-order';
const KEY_SELECTED_TIMESPAN = 'watchlist-selected-timespan';

const DEFAULT_WATCHLIST = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true,
};


export default {
  namespaced: true,
  state: {
    orders: ORDERS,
    timespans: TIMESPANS,
    watchlist: Object.create(DEFAULT_WATCHLIST),
    selectedOrder: ls.get(KEY_SELECTED_ORDER, ORDERS[0]),
    selectedTimespan: ls.get(KEY_SELECTED_TIMESPAN, AVAILABLE_TIMESPANS.ALL),
    shouldShowTimespanFilter: ls.get(KEY_SHOULD_SHOW_TIMESPAN, true),
  },
  mutations: {
    updateWatchlistFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = {
          ...state.watchlist,
          data: state.watchlist.data.map(market => updateMarket(market, data)),
        };
      }
    },
    updateWatchlistContractFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = {
          ...state.watchlist,
          data: state.watchlist.data.map(market => updateMarketContracts(market, data)),
        };
      }
    },
    selectOrder(state, sort) {
      const selectedOrder = find(state.orders, { sort });
      const selectedTimespan = DEFAULT_TIMESPANS[sort] || AVAILABLE_TIMESPANS.EMPTY;
      const shouldShowTimespan = ORDERS_WITH_TIMESPAN_FILTER
        .indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      ls.set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      ls.set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      ls.set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan(state, parameter) {
      const selectedTimespan = find(state.timespans, { parameter });
      state.selectedTimespan = selectedTimespan;
      ls.set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    updateWatchList(state, payload) {
      const sourceData = [...state.watchlist.data];
      const data = uniqBy(sourceData.concat(payload.data.markets || []), 'marketId');
      const page = payload.data.page;
      const totalCount = payload.data.totalMarkets;
      const canLoadMore = totalCount > data.length;

      state.watchlist = {
        ...state.watchlist,
        data,
        page,
        totalCount,
        canLoadMore,
      };
    },
    setWatchlistData(state, payload) {
      state.watchlist = {
        ...state.watchlist,
        data: payload.data,
        page: payload.page,
        totalCount: payload.totalCount,
        canLoadMore: payload.totalCount > payload.data.length,
      };
    },
    resetWatchlist(state) {
      state.watchlist = Object.create(DEFAULT_WATCHLIST);
    },
  },
  actions: {
    async reloadWatchlist({ state, commit }) {
      const totalPages = state.watchlist.page;
      if (totalPages === 0) return;

      const results = await Promise.all(
        Array.from({ length: totalPages }, (_, i) => i + 1).map(page =>
          api.profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page)
        )
      );

      const allMarkets = flatten(results.map(r => r.data.markets || []));
      const data = uniqBy(allMarkets, 'marketId');
      const lastResult = results[results.length - 1].data;
      const totalMarkets = lastResult.totalMarkets || state.watchlist.totalCount;

      commit('setWatchlistData', {
        data,
        page: totalPages,
        totalCount: totalMarkets,
      });
    },
    resetWatchlist({ commit }) {
      commit('resetWatchlist');
    },
    getWatchList({ state, commit }) {
      if (state.watchlist.canLoadMore) {
        const page = state.watchlist.page + 1;
        return api.profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page)
          .then((response) => {
            commit('updateWatchList', {
              page,
              data: response.data,
            });
            return response.data;
          });
      }
      return null;
    },
    selectOrder({ commit, dispatch }, sort) {
      commit('selectOrder', sort);
    },
    selectTimespan({ state, dispatch, commit }, timespan) {
      commit('selectTimespan', timespan);
    },
    updateWatchlistFromNotification({ commit }, payload) {
      commit('updateWatchlistFromNotification', payload);
    },
    updateWatchlistContractFromNotification({ commit }, payload) {
      commit('updateWatchlistContractFromNotification', payload);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/watchlist.js